import { Input } from '@library/components/inputs';
import type { InputProps } from '@library/components/inputs';
import type { Ref } from 'react';
import SearchIcon from '@library/assets/images/Search.png';
import { cn } from '@library/component-utils/cn';
import { formatDateOfBirth } from '@bo-utils/members/members';
import { forwardRef } from 'react';

export interface DateOfBirthInputProps extends InputProps {
  className?: string;
  id: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  showSearchIcon?: boolean;
  value: string;
}

const CustomDateOfBirthInput = (
  {
    className = '',
    id,
    onValueChange,
    placeholder = 'Birth Date (MM-DD-YYYY)',
    showSearchIcon = false,
    value,
    ...rest
  }: DateOfBirthInputProps,
  ref: Ref<HTMLInputElement>
) => {
  const handleOnValueChange = (newValue: string) => {
    const formattedValue = newValue.replace(/[^0-9/-]/g, '');
    const formattedDOB = formatDateOfBirth(formattedValue);
    onValueChange(formattedDOB);
  };

  return (
    <div
      className={cn(
        'border-soFresh-140 bg-soFresh-110 flex h-11 w-full min-w-min rounded-md border py-1.5 sm:leading-6',
        className
      )}
    >
      {showSearchIcon && (
        <div className="pointer-events-none inset-y-0 left-0 flex items-center pl-3">
          <img src={SearchIcon} alt="search" />
        </div>
      )}
      <Input
        className="text-soClean-100 placeholder:text-soClean-180 w-full border-0 bg-transparent text-sm hover:ring-0 focus:ring-0 sm:leading-6"
        type="search"
        id={id}
        pattern="(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-\d{4}"
        placeholder={placeholder}
        maxLength={10}
        onValueChange={handleOnValueChange}
        ref={ref}
        value={value}
        {...rest}
      />
    </div>
  );
};

export const DateOfBirthInput = forwardRef(CustomDateOfBirthInput);
